import { render, staticRenderFns } from "./radioBox.vue?vue&type=template&id=225a197a&scoped=true&"
import script from "./radioBox.vue?vue&type=script&lang=js&"
export * from "./radioBox.vue?vue&type=script&lang=js&"
import style0 from "./radioBox.vue?vue&type=style&index=0&id=225a197a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a197a",
  null
  
)

export default component.exports